import React from 'react';
import { grape } from '../theme/colors';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

const Star = (props: SvgIconProps) => {
  return (
    <SvgIcon htmlColor={grape.medium} {...props}>
      <path d="M12.0015 17.27L16.6597 20.0815C17.2277 20.4243 17.9284 19.9151 17.7777 19.269L16.5415 13.97L20.6579 10.4039C21.1594 9.96951 20.8913 9.14581 20.2302 9.08973L14.8115 8.63L12.692 3.62928C12.4336 3.01951 11.5694 3.01951 11.3109 3.62928L9.19146 8.63L3.77269 9.08973C3.11162 9.14581 2.84356 9.96951 3.34501 10.4039L7.46147 13.97L6.22528 19.269C6.07455 19.9151 6.77523 20.4243 7.34321 20.0815L12.0015 17.27Z" />
    </SvgIcon>
  );
};

export default Star;
